module.exports = __webpack_public_path__ + "img/SAFo_StrongPasswords_Complexity-Tilt.7872186a.svg";